import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';

export class MyScheduleDetailViewController {
  private course: any;

  constructor(private $stateParams: ng.ui.IStateParamsService, private courseDetailCommand: ICommand) {
    this.course = {};
    courseDetailCommand(this.$stateParams.id).then((course: any) => (this.course = course));
  }

  getTitleOfCourse(): string {
    if (_4.isEmpty(this.course)) {
      return '';
    }
    return this.course._course.cd;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-course-schedule/src/views/my_schedule_detail_view/my_schedule_detail_view_controller.ts